(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
        const url = new URL(window.location.href);
          if (url.hash) {
              document.addEventListener(
                    'DOMContentLoaded',
                          () => {
                                  const card = document.getElementById(url.hash.slice(1));
                                          if (card) {
                                                    card.scrollIntoView({ behavior: 'instant' });
                                                            }
                                                                  },
                                                                        { once: true }
                                                                            );
                                                                              }
                                                                              
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  
  // 1. Force Accordions Closed
  document.querySelectorAll('details').forEach((el) => el.removeAttribute('open'));

  // 2. Native Size Chart Injection
  const allElements = document.querySelectorAll('.product-details *');
  function createSizeChartButton() {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'velvory-native-trigger';
    btn.innerHTML = `<svg viewBox="0 0 54 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.08008 7.20001H52.9201V28.8H1.08008V7.20001Z" stroke="currentColor" stroke-width="1.8" stroke-miterlimit="10"></path><path d="M7.19995 18V28.8" stroke="currentColor" stroke-width="1.8" stroke-miterlimit="10"></path><path d="M12.96 23.4V28.8" stroke="currentColor" stroke-width="1.8" stroke-miterlimit="10"></path><path d="M18.72 18V28.8" stroke="currentColor" stroke-width="1.8" stroke-miterlimit="10"></path><path d="M24.48 23.4V28.8" stroke="currentColor" stroke-width="1.8" stroke-miterlimit="10"></path><path d="M30.24 18V28.8" stroke="currentColor" stroke-width="1.8" stroke-miterlimit="10"></path><path d="M36 23.4V28.8" stroke="currentColor" stroke-width="1.8" stroke-miterlimit="10"></path><path d="M41.76 18V28.8" stroke="currentColor" stroke-width="1.8" stroke-miterlimit="10"></path><path d="M47.52 23.4V28.8" stroke="currentColor" stroke-width="1.8" stroke-miterlimit="10"></path></svg> Size Chart`;
    btn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); document.getElementById('VelvorySizeModal').classList.add('is-open'); });
    return btn;
  }
  for (let i = 0; i < allElements.length; i++) {
    const el = allElements[i];
    if (el.childNodes.length > 0 && el.innerText) {
       const text = el.innerText.trim().toLowerCase();
       if (text === 'shoe size' || text === 'size' || text === 'select size') {
         if (['LABEL', 'LEGEND', 'SPAN', 'H3', 'H4'].includes(el.tagName)) {
            if (!el.querySelector('.velvory-native-trigger')) {
                if (el.closest('.product-details')) { el.appendChild(createSizeChartButton()); break; }
            }
         }
       }
    }
  }
  const modal = document.getElementById('VelvorySizeModal');
  if (modal) {
    modal.querySelector('.velvory-close-modal').addEventListener('click', () => modal.classList.remove('is-open'));
    modal.addEventListener('click', (e) => { if (e.target === modal) modal.classList.remove('is-open'); });
  }
});

  } catch(e) { console.error(e); }
})();
})();
